/**
 * MonitoringDashboardPage - System monitoring dashboard
 *
 * Surfaces the MonitoringDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides real-time system monitoring with Core Web Vitals and performance metrics.
 *
 * Route: /admin/monitoring
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconActivityHeartbeat } from '@tabler/icons-react';

import { MonitoringDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function MonitoringDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="red">
            <IconActivityHeartbeat size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Monitoring Dashboard</Title>
            <Text size="sm" c="dimmed">
              Real-time system monitoring with Core Web Vitals and performance metrics
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <MonitoringDashboard />
    </Container>
  );
}

export default MonitoringDashboardPage;
